import { inject } from '@angular/core';
import { of } from 'rxjs';
import { findToolStartCommand, Interceptor, PromptResponse } from '@panaya/ai-chat/domain';
import { AiChatThinkingService } from './ai-chat-thinking.service';

export function createKnowledgeBaseThinkingInterceptor(): Interceptor<PromptResponse> {
    const service = inject(AiChatThinkingService);
    return (response: PromptResponse) => {
        const command = findToolStartCommand(response.commands, (name) => name === 'mcp__success_center_kb__search_knowledge_base');
        if (command) {
            service.notifyThinkingEvent({ state: 'working', translationKey: 'aichat.thinking.tools.search_panaya_knowledge' });
        }
        return of(response);
    };
}
